import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

/* Fetches the living-menu aggregate (/nc/menu/world) — one call that carries
   population, weather, crime mood, server soul, wanted board, cold cases, the
   monthly leak, obituaries, broadcasts, and the caller's personal layers
   (warrant poster, prophecy, mole notice, dead drops, absence decay). */
export function useMenuWorld(active) {
  const [world, setWorld] = useState(null);
  const refresh = useCallback(() => {
    api.get("/nc/menu/world").then((r) => setWorld(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    if (!active) return undefined;
    refresh();
    const t = setInterval(refresh, 90000); // the city moves while you read the menu
    return () => clearInterval(t);
  }, [active, refresh]);
  return { world, refresh };
}
